// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-config-activity{position:relative}.layout-config-activity .ivu-tabs-content{width:100%;height:calc(100% - 40px);position:absolute}", ""]);
// Exports
module.exports = exports;
